import React from 'react'
import { Table } from 'reactstrap'
import '../../stylesheets/SelectControllerList.css'

class SelectControllerList extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            showTeam: props.showTeam || false
        }
        this.handleControllerChecked = this.handleControllerChecked.bind(this)

        // UI Hacks with Refs
        this.headerRow = null
        this.tableBody = null
        this.alignTableHeadersHack = this.alignTableHeadersHack.bind(this)
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.controllers && this.props.controllers.length) {
            this.alignTableHeadersHack()
        }
    }

    componentDidMount() {
        window.addEventListener("resize", this.alignTableHeadersHack)
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.alignTableHeadersHack)
    }

    alignTableHeadersHack() {
        // UI Hacks with Refs
        if (this.tableBody && this.headerRow) {
            let firstRow = this.tableBody.firstChild
            for (let i = 0; i < this.headerRow.childNodes.length; i++) {
                let headerCol = this.headerRow.childNodes[i]
                let col = firstRow.childNodes[i]
                headerCol.style = `width:${col.offsetWidth}px !important;`
            }
        }
    }

    handleControllerChecked = (controller, selected) => (e) => {
        if (!selected.filter(c => c.id === controller.id).length) {
            this.props.onChecked(controller)
        } else {
            this.props.onUnchecked(controller)
        }
    }

    render() {
        let { className, selected, subsControllers, availableTeam, availablePlans } = this.props
        return <div className={"select-controller-list " + className}>
            <Table>
                <thead>
                    <tr ref={r => this.headerRow = r}>
                        <th style={{ width: '10%' }}> </th>
                        <th style={{ width: '30%' }}>Phone</th>
                        <th style={{ width: '18%' }}>Name</th>
                        <th style={{ width: '18%' }}>Team</th>
                        <th style={{ width: '24%' }}>Subscription Plan</th>
                    </tr>
                </thead>
                <tbody ref={b => this.tableBody = b}>
                    { subsControllers.map((c, idx) => {
                            let checked = selected.includes(c)
                            let key = `${c.id}-${c.serialNumber}-${c.name}-${checked}-${idx}`
                            let handler = this.handleControllerChecked(c, selected)
                            return <tr onClick={handler} key={key}>
                                <th scope="row" style={{ width: '10%' }}>
                                    <input type="checkbox" checked={checked} onClick={handler} onChange={e => e} />
                                </th>
                                <td style={{ width: '30%' }}>
                                    <strong>
                                        {c.serialNumber}
                                    </strong>
                                </td>
                                <td style={{ width: '18%' }}>
                                    {c.name || "No Name"}
                                </td>
                                <td style={{ width: '18%' }}>                                   
                                    {availableTeam}
                                </td>
                                <td style={{ width: '24%' }}>
                                    {availablePlans ? availablePlans.map((p) =>
                                        (p.id === c.subscriptionPlan ? p.name : '')
                                    ) : ''
                                    }
                                </td>
                            </tr>
                        })}
                </tbody>
            </Table>
        </div>
    }
}

export default SelectControllerList



// WEBPACK FOOTER //
// ./src/components/ui/SelectControllerList.js